import {SbBlokData, storyblokEditable} from "@storyblok/react";
import React, {PropsWithChildren, useEffect} from "react";
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import php from 'highlight.js/lib/languages/php';
import bash from 'highlight.js/lib/languages/bash';
import sql from 'highlight.js/lib/languages/sql';
import css from 'highlight.js/lib/languages/css';
import Head from "next/head";


// Then register the languages you need
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('php', php);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('sql', sql);
hljs.registerLanguage('css', css);

type IProps = {
    blok?: { code: string, container_size: string } & SbBlokData
} & PropsWithChildren<any>

export default function Code(props: IProps) {
    useEffect(() => {
        hljs.highlightAll();
    }, []);

    return (
        <><Head>
            {/*<link rel="stylesheet"*/}
            {/*      href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/default.min.css"/>*/}
            <link rel="stylesheet"
                  href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/github.min.css"/>
        </Head>
            <div className={props.blok.container_size + ' px-4 sm:px-6 lg:px-8 mx-auto '} {...storyblokEditable(props.blok)}>

                <pre  className={'bg-gray-100 p-4'}><code>{props.blok.code}</code></pre>


            </div>
        </>
    )
}